const createState = () => {
  return {
    sceneId: 0,
    hlookat: 0,
    mapUrl: '',
    mapList: []
  }
}

const state = createState()

const mutations = {
  SET_SCENEID: (state, sceneId) => {
    state.sceneId = sceneId
  },
  SET_HLOOKAT: (state, hlookat) => {
    state.hlookat = hlookat
  },
  SET_MAPURL: (state, mapUrl) => {
    state.mapUrl = mapUrl
  },
  SET_MAPLIST: (state, mapList) => {
    state.mapList = mapList
  },
}

const actions = {
  setSceneId({ commit }, id) {
    commit('SET_SCENEID', id)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
